<div class="notify-templates">
    <ng-container [ngTemplateOutlet]="header"></ng-container>

    <form [formGroup]="formGroup" class="ups-form">
        <mat-radio-group formControlName="defaultTemplateId" class="templates">
            <div class="template-wrapper create-template" [attr.data-content]="'notifyTemplates.CreateNewTemplate' | translate" (click)="openTemplateCreationDialog($event)">
                <upsc-notify-template></upsc-notify-template>
            </div>
            <div class="template-wrapper" *ngFor="let template of templates">
                <upsc-notify-template [template]="template"
                                      (templateRemoved)="onTemplateRemoved($event)"></upsc-notify-template>
            </div>
        </mat-radio-group>
    </form>
</div>

<ng-template #header>
    <div class="ups-page-header">
        <h1 class="page-title">{{'siteMenu.account.manageNotifyTemplates'|translate}}</h1>
    </div>
</ng-template>